import { type AbTastyCampaign, type AbTastyCampaignId } from '@/lib/ab-tasty';
import featureToggles from '@/config/feature-toggles';

// campaign__variant
type ExperimentKey = `${AbTastyCampaignId}__${string}`;

const experimentFeatureToggles: Record<
  ExperimentKey,
  Partial<Record<keyof typeof featureToggles, boolean>>
> = {
  '1204769__1': {
    'cookie-banner': false,
  },
  '1406861__1': {
    'pdp-hero-form': true,
  },
};

export const enableExperimentFeatures = (
  initialFeatureToggles: Record<string, boolean>,
  abTastyTests: AbTastyCampaign[]
): Record<string, boolean> =>
  abTastyTests.reduce(
    (toggles, campaign): Record<string, boolean> => {
      const { campaignId, variationId } = campaign;
      const experimentKey: ExperimentKey = `${campaignId}__${variationId}`;
      const campaignFeatures = experimentFeatureToggles[experimentKey];
      return { ...toggles, ...campaignFeatures };
    },
    { ...initialFeatureToggles }
  );
